var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransporterManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.691,
    height: 25.765,
    viewBox: "0 0 25.691 25.765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transporter_Management",
    "data-name": "Transporter Management",
    transform: "translate(-577.34 -246.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23559",
    "data-name": "Path 23559",
    d: "M602.884,255.433,601.17,247.8a1.3,1.3,0,0,0-1.265-1.012h-19.44A1.3,1.3,0,0,0,579.2,247.8l-1.714,7.634a2.141,2.141,0,1,0,4.108,1.116h.053a2.141,2.141,0,0,0,4.229,0h.053a2.141,2.141,0,0,0,4.229,0h.053a2.141,2.141,0,0,0,4.229,0h.053a2.141,2.141,0,0,0,4.229,0h.053a2.141,2.141,0,1,0,4.108-1.116Z",
    fill: "#03d976"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3483",
    "data-name": "Rectangle 3483",
    width: 19.589,
    height: 3.32,
    rx: 1.66,
    transform: "translate(580.391 269.232)",
    fill: "#03d976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23560",
    "data-name": "Path 23560",
    d: "M648.746,402.031v6.091a.52.52,0,0,1-.52.52H640.5a.52.52,0,0,1-.52-.52v-6.091a.52.52,0,0,0-.52-.52h-2.28a.52.52,0,0,0-.52.52v9.651a.52.52,0,0,0,.52.52h14.365a.52.52,0,0,0,.52-.52v-9.651a.52.52,0,0,0-.52-.52h-2.28A.52.52,0,0,0,648.746,402.031Z",
    transform: "translate(-54.177 -141.31)",
    fill: "#03d976"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22813",
    "data-name": "Group 22813",
    transform: "translate(587.478 259.621)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2839",
    "data-name": "Ellipse 2839",
    cx: 1.644,
    cy: 1.644,
    r: 1.644,
    transform: "translate(1.063)",
    fill: "#03d976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3484",
    "data-name": "Rectangle 3484",
    d: "M2.707,0h0A2.707,2.707,0,0,1,5.415,2.707V5.415a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.707A2.707,2.707,0,0,1,2.707,0Z",
    transform: "translate(0 4.139)",
    fill: "#03d976"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3485",
    "data-name": "Rectangle 3485",
    width: 3.218,
    height: 3.416,
    transform: "translate(1.099 9.356)",
    fill: "#03d976"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporterManagement);
export default __webpack_public_path__ + "static/media/Transporter Management.29cbe7546f4e25d3c92f48f7365bf451.svg";
export { ForwardRef as ReactComponent };